module.exports = __webpack_public_path__ + "assets/images/onca_d3e25a4be5a709b8beb5089bd69b55c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stage-helps/onca.png
// module id = 295
// module chunks = 0